import styled from 'styled-components';
import { SvgIcon } from '@insly/qmt-reactjs-ui-lib';
import { disabledStyles } from 'styles/helpers';

export const ListPagination = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.colors.strokeB};
  padding: 20px 16px;
`;

export const PaginationDelimiter = styled.div`
  display: none;
`;

export const PaginationData = styled.div`
  position: absolute;
  left: 16px;
  ${({ theme }) => theme.text.normal};
`;

export const PaginationDataWithControls = styled(PaginationData)`
  position: static;
  border-left: 1px solid ${({ theme }) => theme.colors.strokeB};
  border-right: 1px solid ${({ theme }) => theme.colors.strokeB};
  padding: 0 16px;
  margin: 0 16px;
`;

export const PaginationControl = styled(SvgIcon)<{ direction?: 'prev' | 'next', disabled?: boolean }>`
  ${({ theme }) => theme.text.normal};
  width: 24px;
  height: 24px;
  stroke: ${({ theme }) => theme.colors.black};
  transform: ${({ direction }) => direction === 'next' ? 'rotate(180deg)' : null};
  ${disabledStyles};
`;
